import { Condition } from 'types';
import { baseQuery } from '../baseQuery';

type TicketRequestParams = {
  ticketTypeId: number;
  description: string;
  customerId?: string;
  jobId?: string;
  technicianId?: string;
  techVisible?: Condition;
};

const techVisibleMap = {
  [Condition.Yes]: '1',
  [Condition.No]: '0',
  [Condition.Empty]: null,
};

export const postTicket = async ({
  ticketTypeId,
  description,
  customerId,
  jobId,
  technicianId,
  techVisible,
}: TicketRequestParams) => {
  const data = await baseQuery('ticket', {
    type: 'POST',
    body: {
      ticket_type_id: ticketTypeId,
      description: description,
      ...(typeof techVisible !== 'undefined' && { technician_visible: techVisibleMap[techVisible] }),
      ...(typeof customerId !== 'undefined' && { customer_id: customerId }),
      ...(typeof jobId !== 'undefined' && { service_id: jobId }),
      ...(typeof technicianId !== 'undefined' && { technician_id: technicianId }),
    },
  });

  return data;
};
